// GA4Component.js - Direct GA4 only (no GTM)
import React, { useEffect, useState } from "react";
import { isAusDomain } from "./components/expertDashboard/clinicalNotesClinicalRoute/lib/utils";

const GTMComponent = () => {
  const [gId, setGId] = useState(null);

  useEffect(() => {
    // Determine GA4 ID based on subdomain
    if (isAusDomain()) {
      setGId("G-6R9WK18T5N");
    } else {
      setGId("G-28HL9LHXGG");
    }
  }, []);

  useEffect(() => {
    if (gId) {
      // Prevent duplicate initialization
      if (window.gtag && window.dataLayer && window.dataLayer.length > 0) {
        // Check if already initialized with this GA ID
        const hasConfig = window.dataLayer.some(item => 
          Array.isArray(item) && item[0] === 'config' && item[1] === gId
        );
        if (hasConfig) {
          return; // Already initialized
        }
      }

      // Ensure dataLayer and gtag are initialized (should be from index.html, but double-check)
      window.dataLayer = window.dataLayer || [];
      if (typeof window.gtag !== 'function') {
        window.gtag = function(...args) {
          window.dataLayer.push(args);
        };
      }

      // Call config IMMEDIATELY (before script loads) - script will process queue when it loads
      window.gtag("js", new Date());
      window.gtag("config", gId, { send_page_view: true });

      // Inject the GA4 script dynamically - ensure it executes
      const existingScript = document.querySelector(`script[src*="gtag/js?id=${gId}"]`);
      if (!existingScript) {
        // Load the GA4 script directly (not through GTM)
        const script = document.createElement('script');
        script.async = true;
        // Use the direct GA4 gtag.js URL (not GTM container)
        script.src = `https://www.googletagmanager.com/gtag/js?id=${gId}&l=dataLayer&cx=c`;
        
        // Add to head immediately
        document.head.appendChild(script);
        
        // Monitor execution
        script.onload = () => {
          // Wait a bit for script to execute
          let checkCount = 0;
          const checkExecution = setInterval(() => {
            checkCount++;
            const isRealGtag = typeof window.gtag === 'function' && 
                              !window.gtag.toString().includes('dataLayer.push');
            
            if (isRealGtag) {
              // Re-send config to ensure it's properly initialized
              window.gtag("config", gId, { send_page_view: true });
              clearInterval(checkExecution);
            } else if (checkCount >= 20) {
              // Script loaded but gtag still queue - script processes queue in background
              clearInterval(checkExecution);
            }
          }, 100);
        };
        
        script.onerror = () => {
          // Script failed to load - silent fail
        };
      }
    }
  }, [gId]);

  return null; // No UI needed
};

export default GTMComponent;